import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const SchoolManageIndexLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'SchoolManageIndex' */ './components/SchoolManageIndex'
		)
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<SchoolManageIndexLazy />} />,
	};
};
